import { json, events } from "@utilities";
import { CLASSNAMES } from "@constants";

/**
 * Handle search in header
 *
 * @param container {HTMLElement} container element
 */

export default () => {
  // set varibles
  const desktop: HTMLElement = document.querySelector(".js-search-desktop");

  const topBarLinks: HTMLElement = desktop.querySelector(".js-tob-bar-links");
  const searchIcon: HTMLElement = desktop.querySelector(".js-search-icon");
  const searchDesk: HTMLElement = desktop.querySelector(".js-search-desk");
  const searchInputDesk: HTMLInputElement = desktop.querySelector(".js-search-input-desk");
  const searchInputMob: HTMLInputElement = document.querySelector(".js-search-input-mob");
  const searchClose: HTMLElement = desktop.querySelector(".js-search-close");
  const btnCancel: HTMLElement = document.querySelector(".js-search-cancel");
  const whispererMob: HTMLElement = document.querySelector(".js-search-whisperer-mob");
  const whispererDesk: HTMLElement = desktop.querySelector(".js-search-whisperer-desk");
  const form: HTMLFormElement = desktop.querySelector(".js-search-form");
  const formMob: HTMLFormElement = document.querySelector(".js-mob-search-form");

  const localization = window.WIDGETS_CONFIG?.general as General;

  // Search desktop
  // Open search input
  if (searchIcon) {
    events.on(searchIcon, {
      click: (event) => {
        event.preventDefault();
        searchDesk.classList.toggle(CLASSNAMES.ACTIVE);
        topBarLinks.classList.toggle(CLASSNAMES.INVISIBLE);
        searchInputDesk.focus();
      },
    });
  }

  // close search input
  events.on(searchClose, {
    click: (event) => {
      event.preventDefault();
      searchDesk.classList.toggle(CLASSNAMES.ACTIVE);
      topBarLinks.classList.toggle(CLASSNAMES.INVISIBLE);
      whispererDesk.classList.remove(CLASSNAMES.ACTIVE);
    },
  });

  const hideSeatchBar = () => {
    searchDesk.classList.remove(CLASSNAMES.ACTIVE);
    topBarLinks.classList.remove(CLASSNAMES.INVISIBLE);
    whispererDesk.classList.remove(CLASSNAMES.ACTIVE);
  };

  // Hide search on excape
  events.on(document.body, {
    keydown: (event) => {
      if (event.key === "Escape") {
        hideSeatchBar();
      }
    },
  });

  events.on(document, {
    click: (event) => {
      const outsideClick =
        typeof event.composedPath === "function" && !event.composedPath().includes(desktop);
      if (outsideClick) {
        hideSeatchBar();
      }
    },
  });

  // Seacrch Mobile
  // Show cancel button
  events.on(searchInputMob, {
    focus: () => {
      btnCancel.classList.remove(CLASSNAMES.HIDDEN);
      if (!json.parseSafe(searchIcon.dataset.persoo)) {
        whispererMob.classList.add(CLASSNAMES.ACTIVE);
      }
    },
  });

  // Clear seacth input & hide cancel button
  events.on(btnCancel, {
    click: () => {
      btnCancel.classList.toggle(CLASSNAMES.HIDDEN);
      if (!json.parseSafe(searchIcon.dataset.persoo)) {
        whispererMob.classList.remove(CLASSNAMES.ACTIVE);
      }
    },
  });

  // Set query param for search
  const setUrlQuery = (event, query) => {
    event.preventDefault();
    const url = `${window.location.origin}${localization.searchUrl}?query=${query}`;
    window.location.href = url;
  };

  events.on(form, {
    submit: (event) => {
      const inputValueDesk: string = searchInputDesk.value;
      setUrlQuery(event, inputValueDesk);
    },
  });

  events.on(formMob, {
    submit: (event) => {
      const inputValueMob: string = searchInputMob.value;
      setUrlQuery(event, inputValueMob);
    },
  });
};
